import { IPageInfo } from './page.types';

export enum NotificationTypeId {
  NewMessage = 0,
  ExaminerImportSuccess,
  ExaminerImportFailed,
  ExaminerBlocked,
  ExportResultSuccess,
  ExportResultFailed,
  ProcedureMessage,
  ExamineeImportSuccess,
  ExamineeImportFailed,
  ExamineeImportNoDataFromExternalSystem,
  ExamineeImportSomeRecordsNotPassValidation,
  ReportFailed,
  ReportFinished,
  ExamSheetDeleteProcessSuccess,
  ExamSheetDeleteProcessFailed,
  DeleteTasksSolutionSheetsInProgress,
  DeleteTasksSolutionSheetsCompletedWithoutIssues,
  DeleteTasksSolutionSheetsCompletedWithIssues,
  UserDeleteFinished,
  CopySessionInProgress,
  CopySessionSuccess,
  CopySessionFailed,
}

export interface Notification {
  id: string;
  from: string;
  content: string;
  sentDate: string;
  isRead: boolean;
  notificationType: NotificationTypeId;
}
export interface NotificationResponse {
  notifications: Notification[];
  pageInfo: IPageInfo;
}

export enum ImportExamineeSourceType {
  File,
  Sioepkz,
  Sioeo,
}
